/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Faq_A4Inputs */

const en_pricing_faq_a4 = /** @type {(inputs: Pricing_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes — students with a valid university email (.edu or equivalent) get the Student plan at a reduced price.`)
};

const de_pricing_faq_a4 = /** @type {(inputs: Pricing_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja — Studierende mit einer gueltigen Uni-E-Mail (.edu oder aequivalent) erhalten den Student-Plan zu einem reduzierten Preis.`)
};

const fr_pricing_faq_a4 = /** @type {(inputs: Pricing_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Each resume tailoring, cover letter generation, or interview preparation session uses 1 AI action. Job search, ATS score checks, and salary data are always free and do not consume AI actions.`)
};

const es_pricing_faq_a4 = /** @type {(inputs: Pricing_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Each resume tailoring, cover letter generation, or interview preparation session uses 1 AI action. Job search, ATS score checks, and salary data are always free and do not consume AI actions.`)
};

const it_pricing_faq_a4 = /** @type {(inputs: Pricing_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Each resume tailoring, cover letter generation, or interview preparation session uses 1 AI action. Job search, ATS score checks, and salary data are always free and do not consume AI actions.`)
};

const nl_pricing_faq_a4 = /** @type {(inputs: Pricing_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Each resume tailoring, cover letter generation, or interview preparation session uses 1 AI action. Job search, ATS score checks, and salary data are always free and do not consume AI actions.`)
};

const pl_pricing_faq_a4 = /** @type {(inputs: Pricing_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Each resume tailoring, cover letter generation, or interview preparation session uses 1 AI action. Job search, ATS score checks, and salary data are always free and do not consume AI actions.`)
};

const fi_pricing_faq_a4 = /** @type {(inputs: Pricing_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Each resume tailoring, cover letter generation, or interview preparation session uses 1 AI action. Job search, ATS score checks, and salary data are always free and do not consume AI actions.`)
};

const da_pricing_faq_a4 = /** @type {(inputs: Pricing_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Each resume tailoring, cover letter generation, or interview preparation session uses 1 AI action. Job search, ATS score checks, and salary data are always free and do not consume AI actions.`)
};

const sv_pricing_faq_a4 = /** @type {(inputs: Pricing_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Each resume tailoring, cover letter generation, or interview preparation session uses 1 AI action. Job search, ATS score checks, and salary data are always free and do not consume AI actions.`)
};

/**
* | output |
* | --- |
* | "Yes — students with a valid university email (.edu or equivalent) get the Student plan at a reduced price." |
*
* @param {Pricing_Faq_A4Inputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_faq_a4 = /** @type {((inputs?: Pricing_Faq_A4Inputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Faq_A4Inputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_faq_a4(inputs)
	if (locale === "fr") return fr_pricing_faq_a4(inputs)
	if (locale === "es") return es_pricing_faq_a4(inputs)
	if (locale === "it") return it_pricing_faq_a4(inputs)
	if (locale === "nl") return nl_pricing_faq_a4(inputs)
	if (locale === "pl") return pl_pricing_faq_a4(inputs)
	if (locale === "fi") return fi_pricing_faq_a4(inputs)
	if (locale === "da") return da_pricing_faq_a4(inputs)
	if (locale === "sv") return sv_pricing_faq_a4(inputs)
	return en_pricing_faq_a4(inputs)
});